/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Cleanup meeting notifications subscriptions across providers.
 */
export interface MeetingNotificationsCleanupParams {
  cleanupGraceMinutes?: number;
}
